export default __webpack_public_path__ + "static/media/jm.9578169d.svg";